<template>

<core-panel>

	<template v-slot:head>

		<h1>Time Together</h1>

		<p>The most time spent together.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in duration" :subtext="item.plays + ' timed play' + ((item.plays > 1) ? 's' : '')" count-text="hour" :key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'duration',
			duration: []
		}

	},

	methods: {

		response: function(json) {

			this.duration = json.duration.duration

		}

	}

}

</script>